// ArtworkTag — free curation keys used by the gallery config to build hand-picked
// sections (e.g. "Featured"). Extend as new curated groupings are needed.
export enum ArtworkTag {
    Featured = 'FEATURED',
    SelectedWorks = 'SELECTED_WORKS',
}

export const ARTWORK_TAG_DISPLAY: Record<ArtworkTag, string> = {
    [ArtworkTag.Featured]: 'Featured',
    [ArtworkTag.SelectedWorks]: 'Selected Works',
};
